import { Component, ViewChild, TemplateRef, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Login } from 'src/app/models/login';
import { LoaderService } from 'src/app/services/loader.service';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { CustomValidators } from 'src/app/shared/validators/custom.validator';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password-modal.component.html',
  styleUrls: ['./reset-password-modal.component.scss'],
})
export class ResetPasswordModalComponent {
  item: Login = new Login();
  isDisableConfirmBtn: boolean = false;

  // #region INPUT, OUTPUT, VIEWCHILD
  @Input() resetCode: string;
  @Input() modalReference: any;
  @ViewChild('resetPasswordModal')
  resetPasswordTemplate!: TemplateRef<ResetPasswordModalComponent>;
  // #endregion

  formGroup = new FormGroup(
    {
      Password: new FormControl('', [
        Validators.required,
        CustomValidators.passwordValidator(),
        Validators.minLength(6),
        Validators.maxLength(25)
      ]),
      NewPassword: new FormControl('', [
        Validators.required,
        CustomValidators.passwordValidator(),
        Validators.minLength(6),
        Validators.maxLength(25)
      ]),
    },
    {
      validators: CustomValidators.confirmPasswordValidator(
        'Password',
        'NewPassword'
      ),
    }
  );

  constructor(
    private authService: AuthService,
    private router: Router,
    private toastr: ToastrService,
    private loaderService: LoaderService
  ) {
    this.item.email = this.authService.getEmail();
    this.authService.userEmail$.subscribe((res) => {
      this.item.email = res;
    });
  }

  onTextValueChange(field) {
    this.fromGroupTouched();
    this.item[field.text] = field.value;
  }

  fromGroupTouched(isSubmit: boolean = false) {
    if (this.formGroup.touched || isSubmit) {
      this.formGroup.markAllAsTouched();
      this.formGroup.updateValueAndValidity();
    }
  }
  onConfirmClick() {
    this.fromGroupTouched(true);

    if (this.formGroup.invalid) return;
    this.loaderService.setLoading(true);

    this.isDisableConfirmBtn = true;
    this.item.password = this.formGroup.get('Password').value;
    this.item.confirmPassword = this.formGroup.get('NewPassword').value;
    this.item.ResetPasswordCode = this.resetCode;
    this.authService.updatePassword(this.item).subscribe((res: string) => {
      if (!res) {
        this.toastr.success('Password reset successful!');
        this.isDisableConfirmBtn = false;
        this.fromReset();
        this.router.navigateByUrl('', { skipLocationChange: true }).then(() => {
          this.router.navigate(['']);
        });
        this.modalReference.close();
      } else {
        this.isDisableConfirmBtn = false;
      }
      this.loaderService.setLoading(false);
    });
  }

  onCancelClick() {
    this.fromReset();
  }

  fromReset() {
    this.item = new Login();
    this.formGroup.reset();
    this.formGroup.updateValueAndValidity();
  }

  enterKeyPress(event) {
    /** Note - keycode 13 mining Enter key */
    if (event.keyCode === 13) {
      this.onConfirmClick();
    }
  }
}
